module.exports = __webpack_public_path__ + "img/cut3img.fcf661e3.png";